/* global axios */
import ApiClient from './ApiClient';

class SegueDashboardAPI extends ApiClient {
  constructor() {
    super('segue_dashboard', { accountScoped: true });
  }

  fetchMetrics({ period = 'today', from = null, to = null, inboxId = null } = {}) {
    const params = { period };
    if (period === 'custom') {
      if (from) params.from = from;
      if (to) params.to = to;
    }
    if (inboxId) params.inbox_id = inboxId;
    return axios.get(`${this.url}/metrics`, { params });
  }

  fetchOpenaiCosts(period = 'today') {
    return axios.get(`${this.url}/openai_costs`, { params: { period } });
  }

  updateOpenaiKey(key) {
    return axios.post(`${this.url}/openai_costs/update_key`, { key });
  }

  fetchBancosResumo({
    period = 'today',
    from = null,
    to = null,
    bankOverrides = null,
  } = {}) {
    const params = { period };
    if (period === 'custom') {
      if (from) params.from = from;
      if (to) params.to = to;
    }
    if (bankOverrides) {
      Object.entries(bankOverrides).forEach(([bank, range]) => {
        if (range?.from) params[`bank_overrides[${bank}][from]`] = range.from;
        if (range?.to) params[`bank_overrides[${bank}][to]`] = range.to;
      });
    }
    return axios.get(`${this.url}/bancos_resumo`, { params });
  }

  // Contratos (UY3 + FACTA). Usa o MESMO filtro de periodo do topo da tela.
  // period=today|yesterday|7d|30d|custom, from/to=YYYY-MM-DD, bank=uy3|facta|all
  fetchContratos({ period = 'today', from = null, to = null, bank = 'all' } = {}) {
    const params = { period, bank };
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(`${this.url}/contratos`, { params });
  }

  // Conversa somente-leitura pelo telefone do cliente.
  fetchConversa(phone) {
    return axios.get(`${this.url}/conversa`, { params: { phone } });
  }

  // Ofertas do dia (view dashboard_ofertas). dia=YYYY-MM-DD (default hoje BRT).
  fetchOfertas(dia = null) {
    const params = {};
    if (dia) params.dia = dia;
    return axios.get(`${this.url}/ofertas`, { params });
  }

  // Performance do TIME (times do Chatwoot) no periodo.
  fetchEquipe({ teamId, period = 'today', from = null, to = null } = {}) {
    const params = { team_id: teamId, period };
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(`${this.url}/equipe`, { params });
  }

  // v91: home leve do Dashboard. v93: periodo selecionavel.
  fetchVisaoGeral({ period = 'today', from = null, to = null } = {}) {
    const params = { period };
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(`${this.url}/visao_geral`, { params });
  }

  // v93: drill-down da tabela de agentes (clientes + ofertas por banco +
  // etiquetas + conversa).
  fetchAgenteLeads({ agentId, tipo, period = 'today', from = null, to = null } = {}) {
    const params = { agent_id: agentId, tipo, period };
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(`${this.url}/visao_geral_agente_leads`, { params });
  }

  // v91: cards + matriz status x banco + matriz por vendedor.
  fetchContratosResumo({ period = 'today', from = null, to = null } = {}) {
    const params = { period };
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(`${this.url}/contratos_resumo`, { params });
  }

  // v91: drill-down — contratos do vendedor na categoria.
  fetchContratosVendedorDetalhe({
    vendedorId,
    categoria = '__total__',
    period = 'today',
    from = null,
    to = null,
  } = {}) {
    const params = { vendedor_id: vendedorId, categoria, period };
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(`${this.url}/contratos_vendedor_detalhe`, { params });
  }
}

export default new SegueDashboardAPI();
